import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { getGuides, getSuggestions, Guide } from '~/monolith-api';

const optionsSchema = z.object({
   query: z.string().optional(),
   order: z.enum(['ASC', 'DESC']).optional(),
   offset: z.number().optional(),
   limit: z.number().optional(),
});

export default createBFFHandlers({
   post: async (req, res) => {
      const monolithClient = getServerSideMonolithClient(req);
      const options = optionsSchema.parse(req.body);

      let results: Guide[];

      if (options.query && options.query.length > 3) {
         const suggestions = await getSuggestions<'guide'>(options.query, {
            doctypes: 'guide',
            includeUnreleased: true,
            showAllLanguages: true,
            apiClient: monolithClient,
         });

         // Currently, there is no way to limit results via query params.
         //    Limiting results here for consistency.
         results = suggestions.slice(0, options.limit);
      } else {
         results = await getGuides({ limit: options.limit, apiClient: monolithClient });
      }

      res.status(200).json(results);
   },
});

export const getGuidesFromClient = (options: GetGuidesOptions): Promise<GetGuidesResult> => {
   return bff()
      .post('/guides/getGuides', options)
      .then(response => response.data);
};

export type GuideBlurb = Omit<Guide, 'flags'> & {
   flags: string[];
};

export type GetGuidesOptions = z.infer<typeof optionsSchema>;

export type GetGuidesResult = GuideBlurb[];
